import { render } from "./Targetologs.vue?vue&type=template&id=cdc209dc"
import script from "./Targetologs.vue?vue&type=script&lang=js"
export * from "./Targetologs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__